// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.set-notification-as-read:before {
  content: "\\2022";
  padding-right: 0.5rem;
  color: #B5B5C3 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/layout/notifications/header-notifications.component.less"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,qBAAA;EACA,yBAAA;AACJ","sourcesContent":[".set-notification-as-read:before{\n    content: \"\\2022\";\n    padding-right: 0.5rem;\n    color:#B5B5C3 !important\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
